import React from "react";
import vtLogo from "../Assets/Images/VTFullLogo.png";
const Header = () => {
  return (
    <div style={{ background: "#350E68", padding: "70px" }}>
      <div
        className="w-100"
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "24px",
        }}
      >
        <img src={vtLogo} alt={"VT Logo"} />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          fontSize: "52px",
          fontWeight: "600",
          width: "100%",
          alignItems: "center",
          color: "#fff",
          marginBottom: "24px",
        }}
      >
        <div>Welcome to</div>
        <div>Vidyut GreenLabs!</div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "#fff",
          gap: "34px",
          fontSize: "18px",
        }}
      >
        <div className="col-6" style={{ textAlign: "center" }}>
          Vidyut Green Labs Private Limited, a wholly owned subsidiary of
          Vidyuttech Services, is a Loan Service Provider (LSP) specializing in
          electric three-wheeler financing. We partner with NBFCs and banks to
          source borrowers, facilitate loan processing, and support collections.
        </div>
        <div className="col-6" style={{ textAlign: "center" }}>
          Our technology-driven approach enhances asset underwriting and
          optimises collections, enabling financiers to expand their EV lending
          portfolios with improved risk management and operational efficiency.
        </div>
      </div>
    </div>
  );
};
export default Header;
